<form #form="ngForm" class="card p-4">
  <div class="row">
    <div class="col-12 mb-4">
      <div class="map">
        <ya-map [center]="[54.714047178, 20.50126476]" [zoom]="12" (yaclick)="clickmap($event)">
          @if (model.location) {
          <ya-placemark [geometry]="[model.location.lat, model.location.lon]"></ya-placemark>
          }
        </ya-map>
      </div>
    </div>
    <div class="col-12">
      <div class="row">
        <div class="col-md-4 col-lg-3 mb-4">
          <div class="form-group">
            <div class="form-check form-switch mb-3">
              <input class="form-check-input" type="checkbox" name="isBranded" [(ngModel)]="model.isBranded">
              <label class="form-check-label">Брендовый</label>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-lg-3 mb-4">
          <div class="form-group">
            <div class="form-check form-switch mb-3">
              <input class="form-check-input" type="checkbox" name="isEnabled" [(ngModel)]="model.isEnabled">
              <label class="form-check-label">Включен</label>
            </div>
          </div>
        </div>

        <div class="col-md-4 col-lg-3 mb-4">
          <div class="input-group">
            <div class="form-floating ">
              <input class="form-control" readonly name="selectedCloseDate" [(ngModel)]="selectedCloseDate"
                ngbDatepicker #dClose="ngbDatepicker" (click)="dClose.toggle()" />
              <label>Дата когда магазин не работает</label>

            </div>
            <span class="input-group-text cursor-pointer" (click)="selectedCloseDate = undefined">
              <i class="fas fa-times text-danger" >
              </i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-3 mb-4">
      <div class="form-group">
        <div class="form-floating mb-3">
          <input type="text" name="name" [(ngModel)]="model.name" class="form-control" required
            placeholder="Название">
          <label>Название</label>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-3 mb-4">
      <div class="form-group">
        <div class="form-floating mb-3">
          <input type="text" name="code" [(ngModel)]="model.code" class="form-control" required
            placeholder="IIKO">
          <label>Код магазина</label>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-3 mb-4">
      <div class="form-group">
        <div class="form-floating mb-3">
          <select name="parentId" [(ngModel)]="model.cityId" class="form-select" placeholder="Выберите город">
            @for (item of cities; track item) {
            <option [value]="item.id" [ngClass]="{
                                            'text-danger': !item.isEnabled
                                        }">
              {{ item.name }}
            </option>
            }
          </select>
          <label>Город</label>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-3 mb-4">
      <div class="form-group">
        <div class="form-floating mb-3">
          <input type="text" name="address" [(ngModel)]="model.address" class="form-control" required
            placeholder="Адрес">
          <label>Адрес</label>
        </div>
      </div>
    </div>
    <div class="col-md-4 col-lg-3 mb-4">
      <div class="form-group">
        <div class="form-floating mb-3">
          <input type="text" name="phone" [inputMask]="phoneMask" [(ngModel)]="model.phone" class="form-control"
            required placeholder="Телефон">
          <label>Телефон</label>
        </div>
      </div>
    </div>

    <div class="col-md-6 col-lg-3 mb-4">
      <div class="form-group">
        <div class="form-floating mb-3">
          <input type="text" name="terminalId" [(ngModel)]="model.terminalId" class="form-control" required
            placeholder="IIKO">
          <label>IIKO Terminal ID</label>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-3 mb-4">
      <div class="form-group">
        <div class="form-floating mb-3">
          <input type="text" name="priceCategoryId" [(ngModel)]="model.priceCategoryId" class="form-control"
            placeholder="IIKO">
          <label>IIKO price category ID</label>
        </div>
      </div>
    </div>

    <div class="col-md-6 col-lg-3 mb-4">
      <div class="form-group">
        <div class="form-floating mb-3">
          <input type="text" name="sectionId" [(ngModel)]="model.sectionId" class="form-control" required
            placeholder="IIKO">
          <label>IIKO section ID</label>
        </div>
      </div>
    </div>

    <div class="col-md-6 col-lg-3 mb-4">
      <div class="form-group">
        <div class="form-floating mb-3">
          <input type="text" name="storeId" [(ngModel)]="model.storeId" class="form-control" required
            placeholder="IIKO">
          <label>IIKO store ID</label>
        </div>
      </div>
    </div>

    <div class="col-md-6 col-lg-3 mb-4">
      <div class="form-group">
        <div class="form-floating mb-3">
          <input type="text" name="organizationId" [(ngModel)]="model.organizationId" class="form-control"
            required placeholder="IIKO">
          <label>IIKO organization ID</label>
        </div>
      </div>
    </div>

    <div class="col-md-6 col-lg-3 mb-4">
      <div class="form-group">
        <div class="form-floating mb-3">
          <input type="text" name="departmentId" [(ngModel)]="model.departmentId" class="form-control" required
            placeholder="IIKO">
          <label>IIKO department ID</label>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6 mb-4">
      <div class="form-group">
        <div class="form-floating mb-3">
          <textarea [(ngModel)]="model.description" name="description" placeholder="Описание" rows="5"
            class="form-control"></textarea>
          <label>
            Описание
          </label>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6 mb-4">
      <div class="d-flex">
        @for (image of model.images; track image) {
        <div class="image mb-2 me-2">
          <img [src]="image.path" />
          <div class="overflow">
            <div class="remove" (click)="removeImage(image)">
              <i class="fa-solid fa-times"></i>
            </div>
            <div class="move">
              <div class="ps-3 p-2 cursor-pointer" (click)="moveImage(image, true)">
                <i class="fa-solid fa-arrow-left"></i>
              </div>
              <div class="p-2 pe-3 cursor-pointer" (click)="moveImage(image, false)">
                <i class="fa-solid fa-arrow-right"></i>
              </div>
            </div>
          </div>
        </div>
        }
      </div>
      <label class="w-100">
        Новое изображение
        <input type="file" (change)="selectFile($event)" class="form-control" accept="image/*" />
      </label>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6 col-lg-3 no-show-btn">
      Время работы
      @for (item of [0,1,2,3,4,5,6]; track item; let i = $index) {
      <div class="row">
        <div class="col-12">
          {{ getWeekdayName(i) }}
        </div>
        <div class="col-md-6 mb-4">
          <div class="form-group">
            <ngb-timepicker name="from{{i}}" class="no-show-btn" [(ngModel)]="workTimes[item].from"
              required></ngb-timepicker>
          </div>
        </div>
        <div class="col-md-6 mb-4">
          <div class="form-group">
            <ngb-timepicker name="to{{i}}" class="no-show-btn" [(ngModel)]="workTimes[item].to"
              required></ngb-timepicker>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
  <div class="row mt-4">
    <div class="col-12">
      <button (click)="save()" [disabled]="form.invalid || !model.location || isBusy" class="btn btn-primary">
        <i class="fa-solid fa-save"></i>&nbsp;Сохранить
      </button>
    </div>
  </div>
</form>

@if (isBusy) {
<div class="overlay">
  <i class="fa-solid fa-spinner fa-spin"></i>
</div>
}
